import React from 'react'

export default function Banner() {
  return (
   <>
   <section class="hero">
        <div class="container">

          <div class="hero-content">

            <p class="hero-subtitle">Filmlane</p>

            <h1 class="h1 hero-title">
              Unlimited <strong>Movie</strong>, TVs Shows, & More.
            </h1>

            <div class="meta-wrapper">

              <div class="badge-wrapper">
                <div class="badge badge-fill">PG 18</div>

                <div class="badge badge-outline">HD</div>
              </div>

              <div class="ganre-wrapper">
                <a href="#">Romance,</a>

                <a href="#">Drama</a>
              </div>

              <div class="date-time">

                <div>
                <i  style={{color:'yellow'}} class="fas fa-calendar-alt"></i>

                  <time datetime="2022">2022</time>
                </div>

                <div>
                <i  style={{color:'yellow'}} class="fas fa-clock"></i>

                  <time datetime="PT128M">128 min</time>
                </div>

              </div>

            </div>

            <button class="btn btn-primary">
            <i class="fas fa-play"></i>
              <span>Watch now</span>
            </button>

          </div>

        </div>
      </section>
   </>
  )
}
